export default __webpack_public_path__ + "static/media/2021.6d58ac94.webp";